module.exports = require("@common-stack/server-core");